import { IFormErrors } from '@interfaces/IFormsErrors';
import { ICard } from '@interfaces/IAccountants';

export interface IAccountantsViewState {
  cards: {
    data: ICard[] | null;
    isLoading: boolean;
  };
  isLoading: boolean;
  errors: IFormErrors | null;
}

export const initialsAccountantsViewState: IAccountantsViewState = {
  cards: {
    data: null,
    isLoading: false,
  },
  errors: null,
  isLoading: false,
};
